import { Link } from "@inertiajs/react"
import { ChevronRight } from "lucide-react"
import { useIntl } from "react-intl"
import { Badge } from "@/components/ui/badge"
import { useFormat } from "@/lib/format"
import type { AttemptSummary } from "@/types/quizzes"

export function AttemptList({ attempts }: { attempts: AttemptSummary[] }) {
  const intl = useIntl()
  const format = useFormat()
  return (
    <ul className="divide-y divide-hairline overflow-hidden rounded-xl border border-hairline bg-page">
      {attempts.map((attempt) => (
        <li key={attempt.id}>
          <Link
            href={`/attempts/${attempt.id}/results`}
            className="flex items-center gap-3 px-4 py-3 no-underline hover:bg-surface"
          >
            <div className="min-w-0 flex-1">
              <div className="truncate text-sm font-medium text-ink-display">{attempt.score}%</div>
              <div className="truncate text-xs text-ink-muted">
                {attempt.finished_on && format.date(attempt.finished_on, { month: "short", day: "numeric", year: "numeric" })} · {format.questionCount(attempt.question_count)}
              </div>
            </div>
            {attempt.retry && <Badge tone="muted">{intl.formatMessage({ id: "quizzes.retry_badge" })}</Badge>}
            <ChevronRight className="h-4 w-4 shrink-0 text-ink-muted" />
          </Link>
        </li>
      ))}
    </ul>
  )
}
